import { ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, Item } from "@/components/Reveal";
import { HAIR_SERVICES } from "@/lib/data";
import { SITE } from "@/lib/site";

export default function Services() {
  return (
    <div data-testid="page-services" className="pt-32 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <div className="grid gap-8 lg:grid-cols-12 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="overline">Hair Services</div>
            <h1 className="font-display text-5xl sm:text-7xl mt-4 tracking-tight text-balance">
              Colour, cut, <span className="italic font-light">crafted.</span>
            </h1>
            <p className="mt-6 max-w-xl text-[hsl(var(--onyx)/0.65)]">
              Every service is tailored around your hair, face shape and
              lifestyle. Prices below are starting from — a personal quote is
              provided at consultation.
            </p>
          </div>
          <div className="lg:col-span-4 lg:text-right">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="services-book-cta"
              className="btn-pill btn-primary"
            >
              Book any service <ArrowUpRight size={16} />
            </a>
          </div>
        </div>

        <Stagger className="grid gap-8 sm:grid-cols-2">
          {HAIR_SERVICES.map((s, i) => (
            <Item key={s.slug}>
              <article
                data-testid={`service-detail-${s.slug}`}
                className={`grid grid-cols-5 gap-6 rounded-[2rem] overflow-hidden bg-white border border-[hsl(var(--onyx)/0.06)] ${
                  i % 2 ? "sm:translate-y-8" : ""
                }`}
              >
                <div className="col-span-2 hover-zoom bg-blush">
                  <img
                    src={s.image}
                    alt={s.name}
                    className="w-full h-full object-cover aspect-[3/4]"
                  />
                </div>
                <div className="col-span-3 p-6 sm:p-8 flex flex-col">
                  <div className="overline">{s.duration}</div>
                  <h2 className="font-display text-3xl sm:text-4xl mt-3 text-[hsl(var(--onyx))]">
                    {s.name}
                  </h2>
                  <p className="mt-3 text-sm sm:text-base text-[hsl(var(--onyx)/0.65)] leading-relaxed">
                    {s.blurb}
                  </p>
                  <div className="mt-auto pt-6 flex items-center justify-between">
                    <span className="text-[hsl(var(--gold))] font-medium">
                      from {s.from}
                    </span>
                    <a
                      href={SITE.bookingUrl}
                      target="_blank"
                      rel="noreferrer"
                      data-testid={`service-book-${s.slug}`}
                      className="btn-pill btn-blush !py-2 !px-4 !text-xs"
                    >
                      Book Now
                    </a>
                  </div>
                </div>
              </article>
            </Item>
          ))}
        </Stagger>

        <Reveal className="mt-20 rounded-[2rem] bg-[hsl(var(--onyx))] text-[hsl(var(--cream))] p-10 sm:p-14 text-center">
          <div className="overline text-[hsl(var(--gold))]">Bespoke Packages</div>
          <h3 className="font-display text-3xl sm:text-5xl mt-3">
            Not sure what you need? Let's design it together.
          </h3>
          <a
            href={SITE.bookingUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="services-consult-cta"
            className="btn-pill btn-blush mt-8"
          >
            Book a consultation
          </a>
        </Reveal>
      </div>
    </div>
  );
}
